/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Redirect, Route, Switch } from 'react-router-dom';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import 'react-phone-number-input/style.css';
import './App.scss';

import { useDispatch, useSelector } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import ScriptTag from 'react-script-tag';
import Notification from './common/components/Notification';
import CustomRoute from './routes/CustomRoute';
import { history } from './index';
import actions from './redux/actions';
import { routes } from './routes';
import theme from './common/material/theme';

export const arrTestEventUid = [
  '9078bb677cde4b8780551655664a3625', // 226
  '9dde870faff040848f3f8fc56735aa1c', // 14
  'efaa34a93e0b4cdb92ae8709eb2f3763' // 23
];

const App = () => {
  const marketplaceUid = new URLSearchParams(window.location.search).get(
    'marketplace'
  );
  // const stripePromise = arrTestEventUid.includes(marketplace_uid) ?
  //   loadStripe(ConfigService.STRIPE_DEV_PUB_KEY) : loadStripe(ConfigService.STRIPE_PROD_PUB_KEY);

  const dispatch = useDispatch();
  const [marketplace, cart] = useSelector(state => [
    state.marketplace,
    state.cart
  ]);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!marketplace.uid) {
      return;
    }

    const storedCartInfo = localStorage.getItem('user.marketplace.cart');
    if (storedCartInfo && storedCartInfo !== 'null') {
      const cartInfo = JSON.parse(storedCartInfo);

      if (cartInfo.marketplace_uid === marketplace.uid) {
        dispatch({
          type: actions.cart.SET_STATE,
          payload: cartInfo.cart
        });
      } else {
        localStorage.removeItem('user.marketplace.cart');
      }
    }
  }, [dispatch, marketplace.uid]);

  useEffect(() => {
    if (!marketplace.uid) {
      return;
    }

    localStorage.setItem(
      'user.marketplace.cart',
      JSON.stringify({ marketplace_uid: marketplace.uid, cart })
    );
  }, [marketplace.uid, cart]);

  useEffect(() => {
    if (
      marketplace &&
      marketplace.country &&
      marketplace.country.language === 'es'
    ) {
      i18n.changeLanguage('es').then();
    }
  }, [i18n, marketplace]);

  return (
    <>
      <span id="event_fb_pixel_id" style={{ display: 'none' }}>
        {marketplace?.fb_pixel_id}
      </span>
      <span id="event_ga_tracking_id" style={{ display: 'none' }}>
        {marketplace?.ga_tracking_id}
      </span>
      <span id="event_google_ads_number" style={{ display: 'none' }}>
        {marketplace?.google_ads_number}
      </span>
      <noscript>
        <img
          alt=""
          height="1"
          src={`https://www.facebook.com/tr?id=${marketplace?.fb_pixel_id}&ev=PageView&noscript=1`}
          style={{ display: 'none' }}
          width="1"
        />
      </noscript>

      <ScriptTag
        isHydrating
        src={`${process.env.PUBLIC_URL}/resources/js/facebook_pixel.js`}
        type="text/javascript"
      />
      <ScriptTag
        isHydrating
        src={`${process.env.PUBLIC_URL}/resources/js/google_analytics.js`}
        type="text/javascript"
      />
      <ScriptTag
        isHydrating
        src={`${process.env.PUBLIC_URL}/resources/js/google_ads.js`}
        type="text/javascript"
      />

      {marketplace.name && (
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{marketplace.name} | mycashless</title>
          <link
            href="https://mycashless.com/account/marketplace"
            rel="canonical"
          />
        </Helmet>
      )}

      <ConnectedRouter basename="/account/marketplace" history={history}>
        <ThemeProvider theme={theme}>
          <Notification/>
          <Switch>
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/`}
              render={() =>
                marketplaceUid ? (
                  <Redirect to={`${process.env.PUBLIC_URL}/${marketplaceUid}`}/>
                ) : (
                  <Redirect to={`${process.env.PUBLIC_URL}/404`}/>
                )
              }
            />
            {routes.map(route => (
              <CustomRoute
                component={route.component}
                event_active={route?.event_active}
                exact={route.exact}
                key={route.path}
                path={`${process.env.PUBLIC_URL}${route.path}`}
                required_auth={route?.required_auth}
              />
            ))}
            {/* <Route component={NotFoundPage}/> */}
          </Switch>
        </ThemeProvider>
      </ConnectedRouter>
    </>
  );
};

export default App;
